import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedCrowdStrikeApp from "./EmbeddedCrowdStrikeApp";
const CrowdStrikeApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("crowdstrike.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("crowdstrike.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "crowdstrike.app.requirement",
      components: { externalLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://www.crowdstrike.com" }) }
    }
  ), " ")), /* @__PURE__ */ React.createElement(EmbeddedCrowdStrikeApp, null));
};
export default CrowdStrikeApp;
